import React from 'react';
import glamorous from 'glamorous';
import withPrismJs from './with-prismjs-hoc';
import { MENU_ENTRIES } from './constants';

const ProductCodeExamples = () => {
  return (
    <div data-subsection={MENU_ENTRIES.productCodesXmlExamples}>
      <h3>
        EXAMPLES OF PRODUCT CODES IN XML
      </h3>
      <br/>

      <div>
        <h4>
          Example: brick with attributes
        </h4>
        <pre>
          <code className="language-xml">
            {`<product_code>
  <publication>2011-12-01</publication>
  <brick>10000732</brick>
  <attribute>
    <type>20000045</type>
    <value>30006665</value>
    <value>30006666</value>
    <value>30006667</value>
  </attribute>
  <attribute>
    <type>20000968</type>
    <value>30008603</value>
  </attribute>
</product_code>`}
          </code>
        </pre>
      </div>
      <br/>
      <div>
        <h4>
          Example: brick without attributes
        </h4>
        <pre>
          <code className="language-xml">
            {`<product_code>
  <publication>2011-12-01</publication>
  <brick>10000917</brick>
</product_code>`}
          </code>
        </pre>
      </div>
      <br/>
      <div>
        <h4>
          Example: segment
        </h4>
        <pre>
          <code className="language-xml">
            {`<product_code>
  <publication>2011-12-01</publication>
  <segment>51000000</segment>
</product_code>`}
          </code>
        </pre>
      </div>
      <br/>
      <div>
        <h4>
          Example: multiple segments
        </h4>
        <pre>
          <code className="language-xml">
            {`<product_code>
  <publication>2011-12-01</publication>
  <segment>51000000</segment>
  <segment>12000000</segment>
</product_code>`}
          </code>
        </pre>
      </div>
      <br/>
      <div>
        <h4>
          Example: multiple Families
        </h4>
        <pre>
          <code className="language-xml">
            {`<product_code>
  <publication>2011-12-01</publication>
  <family>12340000</family>
  <family>43210000</family>
</product_code>`}
          </code>
        </pre>
      </div>
<br/>
      <div>
        <h4>
          Example: multiple of segments, families and classes
        </h4>
        <pre>
          <code className="language-xml">
            {`<product_code>
  <publication>2011-12-01</publication>
  <segment>51000000</segment>
  <segment>15000000</segment>
  <family>12340000</family>
  <family>34310000</family>
  <class>43219800</class>
  <class>58493800</class>
</product_code>`}
          </code>
        </pre>
      </div>

    </div>
  );
};

export default withPrismJs(ProductCodeExamples);



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-code-examples.js